// RouteTracker.js
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';

const RouteTracker = () => {
  const location = useLocation();
  const userType = useSelector((state) => state.auth.userDetails?.user_type);


  useEffect(() => {
    if (location.pathname && location.pathname !== '/') {
      if (location.pathname === '/choicescreen' && (userType === 2 || userType === 3)) {
        localStorage.setItem('currentPage', "/404");
      } else {
        localStorage.setItem('currentPage', location.pathname)
      }
      ;
    }
  }, [location]);

  return null;
};

export default RouteTracker;
